import React from "react";
import FormSelectDropdownField from "../../fields/selectDropdown";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";
import { FormFieldOption } from "../../fields/types";
import SchemaService from "../SchemaService";
import { useStaticData } from "../../../../context/staticData";

/**
 * @name SingleSelectFieldWrapper
 * @param props
 * @constructor
 */
export default function SingleSelectFieldWrapper(props: DynamicFieldConfigType) {
  const staticData = useStaticData();
  const options: Array<FormFieldOption> = React.useMemo(
    () => SchemaService.parseOptions({ schemaObj: props.schemaObj, staticData: staticData }),
    [props.schemaObj, staticData]
  );

  return (
    <React.Fragment>
      <FormSelectDropdownField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        required={props.schemaObj.mandatory}
        disabled={props.schemaObj.disabled}
        options={options}
        validate={props.validationFn}
        conflictValue={props.schemaObj.conflictValue}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
